import * as React from 'react';
import { Region } from '../../BookingsCalendarTypes';
import { Translate } from '../../../../../shared/LanguageService';
import { AdvancedRegionFilter } from './AdvancedRegionFilter';
import { ProductPropertyFilter } from './ProductPropertyFilter';

type AdvancedFiltersLabels = {
    region: string;
    allRegions: string;
    propertyTitle: (value: string) => string;
    productProperties: string;
};

type ExternalProps = {
    regions: Region[];
    selectedRegion: number;
    shouldUseArea: boolean;
    onChangeRegionFilter: (event: React.ChangeEvent<{ value: unknown }>) => void;
    selectedProperties: number[];
    handleChangeSelectedProperties: (event: number[]) => void;
};

type AdvancedFiltersProps = {
    labels: AdvancedFiltersLabels;
} & ExternalProps;

const AdvancedFilters = ({
    selectedRegion,
    onChangeRegionFilter,
    shouldUseArea,
    labels,
    regions,
    selectedProperties,
    handleChangeSelectedProperties
}: AdvancedFiltersProps) => {
    return (
        <>
            <AdvancedRegionFilter
                disabled={shouldUseArea}
                selectedRegion={selectedRegion}
                onChangeRegion={onChangeRegionFilter}
                availableRegions={regions}
                labels={{ region: labels.region, allRegions: labels.allRegions }}
            />
            <ProductPropertyFilter
                labels={{
                    productProperties: labels.productProperties,
                    propertyTitle: labels.propertyTitle
                }}
                onChangeSelectedProperties={handleChangeSelectedProperties}
                selectedProductProperties={selectedProperties}
            />
        </>
    );
};

const AdvancedFiltersTranslationLayer = (props: ExternalProps) => {
    let labels: AdvancedFiltersLabels = {
        region: Translate('orders/list/bookings-calendar/region'),
        allRegions: Translate('orders/list/bookings-calendar/all-regions'),
        propertyTitle: (displayName) => Translate(displayName),
        productProperties: Translate('orders/list/bookings-calendar/product-properties')
    };

    return <AdvancedFilters labels={labels} {...props} />;
};

export default AdvancedFiltersTranslationLayer;
